import { Button, Grid, Group, NumberInput, TextInput } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { useForm } from '@mantine/form';

import { CustomCollapse } from '@/shared';
import { transformDateFilter } from '@/shared/utils/helpers/datetime-format';

import type { TH2HPaymentFilters } from '../store/types';

type Props = {
  onSubmit: (data: TH2HPaymentFilters) => void;
  onReset: () => void;
};

export const H2HPaymentsFilter = ({ onSubmit, onReset }: Props) => {
  const form = useForm<TH2HPaymentFilters>({ mode: 'uncontrolled', initialValues: {} });

  const handleSubmit = (values: TH2HPaymentFilters) => {
    onSubmit({
      ...values,
      createdFrom: values.createdFrom
        ? transformDateFilter(values.createdFrom).dateFrom
        : undefined,
      createdTo: values.createdTo
        ? transformDateFilter(values.createdTo).dateTo
        : undefined,
    });
  };

  const handleReset = () => {
    form.reset();
    onReset();
  };

  return (
    <CustomCollapse title="Фильтр">
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Grid>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <NumberInput label="ID платежа" key={form.key('id')} {...form.getInputProps('id')} />
            <TextInput label="ID клиента" key={form.key('payerId')} {...form.getInputProps('payerId')} />
            <NumberInput label="ID магазина" key={form.key('shopId')} {...form.getInputProps('shopId')} />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <Group grow>
              <DatePickerInput
                valueFormat="DD.MM.YYYY"
                label="Дата (от)"
                clearable
                key={form.key('createdFrom')}
                {...form.getInputProps('createdFrom')}
              />
              <DatePickerInput
                valueFormat="DD.MM.YYYY"
                label="Дата (до)"
                clearable
                key={form.key('createdTo')}
                {...form.getInputProps('createdTo')}
              />
            </Group>
            <NumberInput label="ID метода" min={1} key={form.key('methodId')} {...form.getInputProps('methodId')} />
            <TextInput label="AvePay remote ID" key={form.key('remoteId')} {...form.getInputProps('remoteId')} />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <TextInput
              label="Реквизиты / банк"
              key={form.key('credentials')}
              {...form.getInputProps('credentials')}
            />
            <Group justify="flex-end" mt={25}>
              <Button variant="outline" onClick={handleReset}>Сбросить</Button>
              <Button type="submit">Применить</Button>
            </Group>
          </Grid.Col>
        </Grid>
      </form>
    </CustomCollapse>
  );
};
